import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { PostPlayerSignUpRequest } from '../type/types';

interface postPlayerSignUpProps {
  loginId: string; // 로그인 ID
}

/** 관리자: 플레이어 회원가입 */
export const postPlayerSignUp = async (data: PostPlayerSignUpRequest) => {
  const res = await api.post<ApiResponseType<postPlayerSignUpProps>>(
    '/api/web/admins/players',
    data
  );
  return res.data;
};
